module.exports = __webpack_public_path__ + "8c114bb706e18d538d12c4f133bbfca7.png";